import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ConversationsTaxonomy from '../components/ConversationsTaxonomy';
import Track from '../../shared/utils/trackers/ZorseCrmComponentsTracker';
import { fetchPropertiesMeta, fetchPropertiesForThread, resolveUpdatePropertyError, setPropertyForThread } from '../actions/ConversationsTaxonomyActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ConversationsTaxonomyContainer = ({
  threadId
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchPropertiesMeta());
  }, [dispatch]);
  useEffect(() => {
    dispatch(fetchPropertiesForThread(threadId));
    dispatch(resolveUpdatePropertyError());
  }, [dispatch, threadId]);
  const propertiesMeta = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.propertiesMeta);
  const threadRecord = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.threadProperties);
  const propertyUpdateStatus = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.propertyUpdateStatus);
  const patchPropertyChange = property => {
    Track.updateThreadProperty(threadId, property.name, property.value);
    dispatch(setPropertyForThread(threadId, property, threadRecord));
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(ConversationsTaxonomy, {
      displayMode: "card",
      onPropertyChange: patchPropertyChange,
      propertiesMeta: propertiesMeta,
      propertyUpdateStatus: propertyUpdateStatus,
      threadId: threadId,
      threadRecord: threadRecord
    })
  });
};
ConversationsTaxonomyContainer.propTypes = {
  threadId: PropTypes.string.isRequired
};
export default ConversationsTaxonomyContainer;